import * as angular from "angular";
import { Observable } from "rxjs";

export class EventService {
    public matchChange: Observable<any>;

    public static $inject = ["$rootScope"];
    constructor($rootScope: angular.IRootScopeService) {
        this.matchChange = Observable.create(observer => {
            $rootScope.$on("onTeMatchChange", function(event, jsonData) {
                this.matchChange.next(jsonData);
            });
        });
    }
}
